<div class="modal fade" id="notification-modal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header hyperion-t4">
        Cast Profile Notification
      </div>
      <div class="modal-body">
        @if (errorText) {
          <p class="text-danger">{{ errorText }}</p>
        }
        @if (loading) {
          <ls-loading-spinner [centered]="true"></ls-loading-spinner>
        } @else {
          <app-notification-carousel [notifications]="notifications" (notificationSeen)="updateSeen($event)"></app-notification-carousel>
        }
      </div>
      <div class="modal-footer">
        <wdpr-button (click)="acknowledgeAll()" [disabled]="loading || !hasSeenAll">
          @if (loading || confirming) {
            <ls-loading-spinner></ls-loading-spinner>
          } @else {
            Acknowledge {{ notifications.length > 1 ? 'all' : '' }}
          }
        </wdpr-button>
      </div>
    </div>
  </div>
</div>
